module.exports = __webpack_public_path__ + "media/images/front/icon_db-a7302b1435dfb14a8e248ea520b54336.png";